import { AxiosRequestConfig, AxiosResponse } from 'axios'
import getAxios from './axios'
import { BlueprintInput } from '../types/BlueprintInput'
import { BlueprintCoordinatesInput, EditPowerSupplyUploadInput } from '../types'
import { Upload, UploadWithLink } from '../types/Upload'
import createAPIClient from '../services/apiClient'
import UploadType from '../enums/UploadType'
import { Filter } from '../types/Filter'

const axios = getAxios()

//POST
export async function postUpload(upload: unknown): Promise<unknown> {
  const response: AxiosResponse = await axios.post('/uploads', upload, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  })
  return response.data
}

//UPDATE COORDINATES
export async function updateCoordinates(
  id: string,
  input: BlueprintCoordinatesInput
): Promise<UploadWithLink> {
  const response: AxiosResponse = await axios.put(`/uploads/${id}`, input)
  return response.data
}

//GET /:id
export async function getUpload(id: string): Promise<{ url: string }> {
  const response: AxiosResponse = await axios.get(`/uploads/${id}`)
  return response.data
}

//GET by type and name
export async function getUploads(input: Filter): Promise<Upload[]> {
  const response: AxiosResponse = await axios.get(`/uploads`, {
    params: {
      type: input.type,
      name: input.name
    }
  })
  return response.data
}

//DELETE
export async function deleteUpload(id: string): Promise<void> {
  await axios.delete(`/uploads/${id}`)
}

// GET blueprint
export async function getBlueprintService(input: BlueprintInput): Promise<UploadWithLink> {
  const response: AxiosResponse = await axios.get(`/uploads/level-blueprint`, {
    params: {
      project: input.project,
      level: input.level
    }
  })
  return response.data
}

const api = createAPIClient('v2')

export async function updatePowerSupplyDocument(
  id: string,
  input: EditPowerSupplyUploadInput
): Promise<Upload> {
  const response = await api.put(`/uploads/${id}`, input)
  return response.data
}

export async function getPowerSupplyDocuments(
  powerSupply?: number,
  config: AxiosRequestConfig = {}
): Promise<Upload[]> {
  const response = await api.get(`/uploads`, {
    ...config,
    params: {
      type: UploadType.POWER_SUPPLY_DOCUMENT,
      powerSupply
    }
  })
  return response.data
}

export default {
  postUpload,
  getUpload,
  getUploads,
  deleteUpload,
  getBlueprintService
}
